import { render, staticRenderFns } from "./MealMainInfo.vue?vue&type=template&id=20cb4b6c&scoped=true&"
import script from "./MealMainInfo.vue?vue&type=script&lang=js&"
export * from "./MealMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./MealMainInfo.vue?vue&type=style&index=0&id=20cb4b6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb4b6c",
  null
  
)

export default component.exports